import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import FilmDetail from "@/pages/detail/page";
import NewsListPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:type",
    element: <CategoryPage />,
  },
  {
    path: "/detail/:id",
    element: <FilmDetail />,
  },
  {
    path: "/news",
    element: <NewsListPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;